import { randomInt } from '@10000/common'
import { useBreakpoints, useInstance, useRequest, useView } from '@10000/react'
import { InputScreen, signUpBackground, useBackground, useShell, useStack } from '../layout'
import { Avatar, Password } from '../forms'
import { Box, H3 } from '../widgets'
import { Industry } from './account'
import { Subscriptions } from './payment'
import { assetUrl } from '../../utilities.js'
import { authenticate } from '../auth/request.js'

export const PasswordSetUp = ({ active, challenge, session, username, fromFreeSquiz }) => {
  const { setInstance } = useInstance()
  const { user: { id, avatar = randomInt(6) } = { } } = useView('tenant')
  const { replaceStack } = useStack()
  const request = useRequest('tenant')
  const { mobile } = useBreakpoints()

  useBackground().set(mobile => ({
    active,
    fade: false,
    ...signUpBackground(mobile, challenge !== 'NEW_PASSWORD_REQUIRED', true)
  }))
  useShell({
    active,
    ...challenge === 'NEW_PASSWORD_REQUIRED'
      ? { mode: 'logo narrow' }
      : { mode: 'progress narrow', step: fromFreeSquiz ? 4 : 3, max: fromFreeSquiz ? 4 : 6 }
  })

  const handleSetPassword = async ({ avatar, password }) => {
    if(challenge === 'NEW_PASSWORD_REQUIRED') {
      const { user } = await authenticate(username, password, session)
      setInstance({ id: user.tenantId, region: user.region })
    } else {
      await request('passwordSet', { password })
      await request('avatarUpdated', { avatar })
      replaceStack(fromFreeSquiz ? Industry : Subscriptions, { props: { fromFreeSquiz } })
    }
  }

  return <InputScreen fade footerButton="Next" onSubmit={handleSetPassword} formValues={{ avatar }}>
    {challenge === 'NEW_PASSWORD_REQUIRED'
      ? <video src={assetUrl('videos/create-account.mp4')} autoPlay muted playsInline loop style={{ width: 150 }} />
      : <Avatar
          edit={id !== undefined}
          name="avatar"
          size={mobile ? 'medium' : 'large'}
          label="ADMIN"
          labelColor="white"
          labelBackground="var(--red)"
        />
    }
    <H3 align="center">Set up your password</H3>
    <Box fullWidth column alignItems="center" className="inputs-container">
      <Password
        useConfirmedPassword
        showPasswordRequirements
      />
    </Box>
  </InputScreen>
}